export const USERS = 'users';
export const POSTS = 'posts';
export const MEDIA = 'media';
export const COMMENTS = 'comments';
export const SUBSCRIPTIONS = 'subscriptions';
export const NOTIFICATIONS = 'notifications';
export const INVITES = 'invites';



// WEBPACK FOOTER //
// ./src/firebase/collectionTypes.js